import React, {useEffect, useState} from 'react';
import {Box, Grid, Typography} from "@material-ui/core";
import {useSnackbar} from "notistack";
import {useEquivalenciasService} from "services/hooks";
import {CodigoEquivalente} from "components/helpers/equivalencias/codigoEquivalente";

/**
 * Equivalencias de un artículo, para mostrar dentro del popup de información.
 * Los códigos que existen en el catálogo son clickeables y abren su detalle.
 *
 * @param onNavigate opcional. Si viene, al hacer click se delega el id al padre en
 *                   lugar de abrir otro diálogo encima (ver CodigoEquivalente).
 */
export const ArticuloEquivalencias = ({idArticulo, onNavigate}) => {
    const [grupos, setGrupos] = useState([]);
    const [cargado, setCargado] = useState(false);

    const EquivalenciasService = useEquivalenciasService();
    const {enqueueSnackbar} = useSnackbar();

    useEffect(() => {
        if (!idArticulo) return;

        EquivalenciasService.getByArticulo(
            idArticulo,
            response => {
                setGrupos(response.data.result);
                setCargado(true);
            },
            error => {
                setCargado(true);
                enqueueSnackbar(error, {variant: 'error'});
            }
        );
    }, [idArticulo]);

    if (!cargado) return null;

    // Muestro los códigos de los otros artículos/marcas, no el del artículo actual.
    const equivalentes = grupos
        .reduce((codigos, grupo) => codigos.concat(grupo.codigos), [])
        .filter(codigo => codigo.codigo !== String(idArticulo).toUpperCase());

    if (equivalentes.length === 0)
        return (
            <Typography color={"textSecondary"} align={"center"} variant={"body2"}>
                No se cargaron equivalencias para este artículo
            </Typography>
        );

    // Una columna por marca, con sus códigos apilados debajo. Agrupar así mantiene la
    // cantidad de columnas acotada a la de marcas (y no a la de códigos), que es lo que
    // permite que entren todas en una sola línea.
    const marcas = [];
    equivalentes.forEach(codigo => {
        let marca = marcas.find(marca => marca.id === codigo.marca);

        if (!marca) {
            marca = {id: codigo.marca, codigos: []};
            marcas.push(marca);
        }

        marca.codigos.push(codigo);
    });

    return (
        // `xs` sin valor reparte el ancho en partes iguales, así que las marcas entran
        // en una línea. `zeroMinWidth` deja que los códigos largos corten en vez de
        // desbordar la columna.
        <Grid container spacing={1}>
            {marcas.map(marca => (
                <Grid item xs zeroMinWidth key={marca.id}>
                    <Box display={"flex"} flexDirection={"column"}>
                        <Typography variant={"caption"} color={"textSecondary"} noWrap>
                            {marca.id}
                        </Typography>
                        {marca.codigos.map((codigo, index) => (
                            <Box key={`${codigo.codigo}-${index}`} style={{wordBreak: 'break-word'}}>
                                <CodigoEquivalente codigo={codigo} onNavigate={onNavigate}/>
                            </Box>
                        ))}
                    </Box>
                </Grid>
            ))}
        </Grid>
    );
};
